import { splitProps } from "solid-js";
import type { IconProps } from "~/types/icon";

export type ArrowDirection = "left" | "right";

export interface ArrowIconProps extends Omit<IconProps, "direction"> {
  direction?: ArrowDirection;
}

/** SVG path data for each direction */
const PATHS: Record<ArrowDirection, string> = {
  left: "M6.75 15.75L3 12M3 12L6.75 8.25M3 12H21",
  right: "M17.25 8.25L21 12M21 12L17.25 15.75M21 12H3",
};

/**
 * Unified arrow icon with direction support (V2 style).
 *
 * @example
 * <ArrowIcon direction="left" />
 * <ArrowIcon direction="right" class={styles.icon} />
 */
export default function ArrowIcon(props: ArrowIconProps) {
  const [local, others] = splitProps(props, ["class", "classList", "direction"]);
  const direction = () => local.direction ?? "right";
  const path = () => PATHS[direction()];

  return (
    <svg
      class={local.class}
      classList={local.classList}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        d={path()}
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
